import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import darkTheme from '../../../src/theme';
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import LocationIcon from "../../../public/images/icons/Vector.png";
import CloseIcon from "../../../public/images/icons/CloseNew.png";
import Image from "next/image";

const ticketTitleCard = {
    background: darkTheme.palette.background.default,
    position: '-webkit-sticky',
    position: 'sticky',
    top: '0px',
    paddingLeft: darkTheme.spacing(4),
    paddingRight: darkTheme.spacing(4),
    paddingTop: darkTheme.spacing(3),
    paddingBottom: darkTheme.spacing(1.5),
    zIndex: 999,
    borderBottom: `1px solid #525252`,
    '& h4': {
        fontSize: 20,
        color: darkTheme.palette.primary.artist,
        fontWeight: 400,
        textTransform: 'capitalize !important',
        marginBottom: darkTheme.spacing(1),
    },
    '& h5': {
        fontSize: 16,
        color: darkTheme.palette.primary.dates,
        fontWeight: 400,
        textTransform: 'capitalize !important',
    },
    '& h6': {
        fontSize: 14,
        color: darkTheme.palette.primary.location,
        textTransform: 'capitalize !important',        
    },
};

function Title({data, totalNoOfTickets, onClose,emptyBeforeClose }) {    
  return (
      <>            
        <Typography component="div" sx={ticketTitleCard}>
              <Stack
                  display="flex"
                  justifyContent="space-between"
                  flexDirection="row"
              >
                    <Typography component="div">  
                        <Typography variant="h4">{data.title.toLowerCase()}</Typography>                      
                      <Typography variant="h6" sx={{mb:1}}>
                        <>
                            <Image
                            src={LocationIcon}
                            alt=""
                            width={10}
                            height={13}
                            layout="fixed"
                            />
                            &nbsp;&nbsp;
                            {data.club_title ? data.club_title+", ": ""}
                            {data.area_name ? data.area_name+ ", " : ""} 
                            {data.cityName}                                                       
                        </>
                      </Typography>
                      <Typography component="h5" sx={{mb:1}}>{data.start_time.slice(0, 5)}{" - "}{data.end_time.slice(0, 5)}{" "}Hrs Onwards</Typography>
                      <Typography component="h6" sx={{textTransform:'unset !important'}}>Valid For {data.entry_free_upto} Person(s)</Typography>
                    </Typography>
                  <Typography component="div">
                    {totalNoOfTickets > 0 ? (
                        <a href="javascript:void(0)" onClick={emptyBeforeClose} style={{ color: "#fff", cursor: "pointer" }}>
                            <Image src={CloseIcon} />
                        </a>
                    ) : (
                        <a href="javascript:void(0)" onClick={onClose} style={{ color: "#fff", cursor: "pointer" }}>
                            <Image src={CloseIcon} />
                        </a>
                    )}
                  </Typography>
            </Stack>
        </Typography>                          
    </>
  );
}

export default Title;

